import { useState } from 'react';
import { Dashboard } from '../components/Dashboard';
import { AdminPanel } from '../components/AdminPanel';
import { DataProvider } from '../context/DataContext';
import { useToast } from "@/hooks/use-toast";

const ADMIN_PASSWORD = 'Surgical2025';

const Index = () => {
  const [currentView, setCurrentView] = useState<'dashboard' | 'admin'>('dashboard');
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const { toast } = useToast();

  const handleAdminAuthentication = (password: string) => {
    if (password === ADMIN_PASSWORD) {
      setIsAdminAuthenticated(true);
      setCurrentView('admin');
      toast({
        title: "Access Granted",
        description: "Welcome to the admin panel.",
      });
    } else {
      toast({
        title: "Access Denied",
        description: "Invalid password. Please try again.",
        variant: "destructive"
      });
    }
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
    setCurrentView('dashboard');
    toast({
      title: "Logged Out",
      description: "You have been logged out of the admin panel.",
    });
  };

  const handleAdminAccess = () => {
    setCurrentView('admin');
  };

  const handleNavigateToDashboard = () => {
    setCurrentView('dashboard');
  };

  return (
    <DataProvider>
      {currentView === 'admin' ? (
        <AdminPanel
          isAuthenticated={isAdminAuthenticated}
          onAuthenticate={handleAdminAuthentication}
          onLogout={handleAdminLogout}
          onNavigateToDashboard={handleNavigateToDashboard}
        />
      ) : (
        <Dashboard onAdminAccess={handleAdminAccess} />
      )}
    </DataProvider>
  );
};

export default Index;
